import { observer } from 'mobx-react-lite';
import { Suspense, SyntheticEvent, useState } from 'react';
import {
  Card,
  Header,
  Grid,
  Icon,
  Label,
  Segment,
  Form,
  Input,
  Button,
  Checkbox,
  Modal,
  Dropdown,
} from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { v4 as uuid } from 'uuid';
import { Template, TemplateTask } from '../../../app/models/template';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import { useEffect } from 'react';
import {
  cardcolor,
  errorDot,
  errorEmptyText,
  errorMessageText,
  selectionEmptyErrorMsg,
} from '../../../app/common/form/errorMessageText';
import WorkflowSubtasks from './WorkflowSubtasks';
import sendRespectiveEmail from '../../../app/models/EmailNew';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import DeleteModal from '../../../library/deleteModal';

const cardStyleLevel1 = {
  display: 'inline-block',
  padding: '10px',
  height: '73vh',
  width: '200pt',
  marginLeft: '2px',
  marginTop: '85px',
  color: 'black',
  cursor: 'pointer',
  boxShadow: '5px 5px 10px lightgray',
};
function WorkflowTasks() {
  const {
    TemplateStore,
    activityStore,
    userStore,
    RolesAndPermissionsIDStore,
    workflowConfigurationStore,
    commonStore,
  } = useStore();

  //const declaration
  const {
    selectedTemplate,
    loadTaskById,
    createTasksUnderTemplate,
    loadingInitialTask,
    selectedTasks,
    UpdateTemplate,
    editTasks,
    deleteTaskType,
    cloneTasks,
    loadParallelTaskUpdate,
  } = TemplateStore;
  const [getnewtaskkey, setgetnewtaskkey] = useState<string | null>();
  const [newTask, setNewTask] = useState<string>('');
  const [temptasks, settemptasks] = useState<TemplateTask[] | undefined>(
    selectedTemplate?.tasks,
  );
  const [errorType, setErrorType] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [templateTask, setTemplateTask] = useState<TemplateTask>({
    taskId: '',
    taskName: '',
    userName: '',
    taskDateTime: '',
    isActive: false,
    isDeleted: false,
    taskIndex: 0,
    subTasks: [],
    templateTaskId: '',
    isParallel: false,
    dependencyTask: '',
  });
  const [showSettingsModal, setShowSettingsModal] = useState<boolean>(false);
  const [options, setOptions] = useState<any[]>([]);

  useEffect(() => {
    setErrorType('');
    settemptasks(selectedTemplate?.tasks);
    // eslint-disable-next-line
  }, [selectedTemplate]);

  useEffect(() => {
    if (selectedTasks !== undefined) {
      workflowConfigurationStore.setShowSubTaskClicked(selectedTasks.isActive);
    }
    // eslint-disable-next-line
  }, [selectedTasks]);

  const handleSettingsClick = async (index: number, tasks: any, taskId:string) => {
    setShowSettingsModal(true);
    setTemplateTask((prevTemplateTask) => ({
      ...prevTemplateTask,
      ...tasks,
    }));
    await TemplateStore.loadParallelTaskSelected(taskId);
    setTemplateTask((prevTemplateTask) => {
      return {
        ...prevTemplateTask,
        dependencyTask: commonStore.NFAIReportCustomer && TemplateStore.parallelSelectedResponse.dependencyTask?.length > 1 
        ? TemplateStore.parallelSelectedResponse.dependencyTask?.split(',') : TemplateStore.parallelSelectedResponse.dependencyTask,
        isParallel: TemplateStore.parallelSelectedResponse.isParallel
      };
    });
    await TemplateStore.loadParallelTasks(
      selectedTemplate?.templateId || '',
      index,
    );
    if (index !== 1) {
      setOptions(
        TemplateStore.parallelResponse.map((item) => ({
          key: item.taskId,
          text: item.taskName,
          value: `${item.taskId}|${item.taskName}`,
        })),
      );
    }else{
      setOptions([])
    }
  };


  const handleCloseSettingsModal = () => {
    setShowSettingsModal(false);
  };

const handleDropdownChange = (
  event: React.SyntheticEvent<HTMLElement>,
  data: any,
) => {
  const value = data.value;

  if (!value) return;

  const updatedDependencyTask = commonStore.NFAIReportCustomer
    ? value
    : options.find((option) => option.value === value)?.value;

  if (updatedDependencyTask) {
    setTemplateTask((prev) => ({
      ...prev,
      dependencyTask: updatedDependencyTask,
    }));
  }
};


  const handleCheckboxChange = () => {
    setTemplateTask((prevTemplateTask) => ({
      ...prevTemplateTask,
      isParallel: !prevTemplateTask.isParallel,
    }));
  };

  const handleTaskSettingsSave = () => {
    const payload = {
      dependencyTask: templateTask.isParallel
        ? ''
        : templateTask.dependencyTask &&
            templateTask.dependencyTask.includes('undefined')
          ? ''
           : commonStore.NFAIReportCustomer && Array.isArray(templateTask.dependencyTask) ? templateTask.dependencyTask?.join(',')

          : templateTask.dependencyTask,
      isParallel: templateTask.isParallel,
    };
    loadParallelTaskUpdate(templateTask.taskId, payload);
    handleCloseSettingsModal();
  };

  const handleChangeName = (e: SyntheticEvent, data: any) => {
    setNewTask(data.value);
    const NameCheck = temptasks?.some(function (el) {
      function ciEquals(a: string, b: string) {
        return typeof a === 'string' && typeof b === 'string'
          ? a.trim().localeCompare(b.trim(), undefined, {
              sensitivity: 'accent',
            }) === 0
          : a.trim() === b.trim();
      }
      return ciEquals(el.taskName, data.value);
    });
    setErrorType(NameCheck ? 'SameName' : ''); //check name exists
    if (data.value.includes('.')) {
      setErrorType('dot');
    }
  };
  /////////////////this function to handle when Enter Key is pressed
  const handleKeyPress = (e: any) => {
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedTask ===
        false &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newTask?.charAt(0) || '')
    ) {
      // if(newTask.includes("") === false){
      hanldeAddTasks();
      // }
    }
    if (
      e.key === 'Enter' &&
      workflowConfigurationStore.WorkflowConfiguration.editClickedTask ===
        true &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newTask?.charAt(0) || '')
    ) {
      handleSaveEdited('edit');
    }
  };
  const handleTaskJSX = (id: string) => {
    if (
      workflowConfigurationStore.WorkflowConfiguration.disableClick === false
    ) {
      setErrorType('');
      loadTaskById(id); // load tasks
      workflowConfigurationStore.setTaskName(id); //set task name
      workflowConfigurationStore.setShowSubTaskCard(true); // show subtasks
      workflowConfigurationStore.setShowElementCard(false); // set  task, subtask, element   false
    }
    //ResetEdit
    workflowConfigurationStore.resetEditClickedButtonExceptTask();
  };
  //////////////////toggle ON off data
  const toggleOn = (e: any, data: any, tasks: TemplateTask) => {
    const newArr = {
      ...tasks,
      isActive: data.checked,
    };
    editTasks(newArr);
    workflowConfigurationStore.setShowSubTaskClicked(data.checked);
  };
  //////////////////////////////////// Add  Tasks Function
  const hanldeAddTasks = () => {
    if (
      selectedTemplate !== undefined &&
      newTask.length !== 0 &&
      errorType !== 'dot' &&
      errorType !== 'EmptyName' &&
      errorType !== 'SameName' &&
      !/\s/g.test(newTask?.charAt(0) || '')
    ) {
      const IdForReference = uuid();
      const tasks = selectedTemplate?.tasks;
      const newArr = {
        taskId: IdForReference,
        taskName: newTask,
        userName: 'bob',
        taskDateTime: activityStore.updateDateTime(),
        isActive: true,
        taskIndex:
          selectedTemplate?.tasks.length === 0
            ? 0
            : selectedTemplate?.tasks.length + 1,
        templateTaskId: IdForReference.toString(),
        isDeleted: false,
        subTasks: [],
      };
      // for backend
      const selectedTemplateArr = {
        ...selectedTemplate,
        tasks: [newArr],
      };
      // for front end schema
      tasks.push(newArr);
      const AllvaluefrontEndData = {
        ...selectedTemplate,
        tasks: tasks,
      };
      //For roles and permissions
      const newRoleArr = {
        id: uuid(),
        itemId: IdForReference,
        rolesId:
          userStore.user?.roleId !== undefined ? userStore.user?.roleId : '',
      };
      settemptasks(tasks);
      RolesAndPermissionsIDStore.createRoleID(newRoleArr);
      //set value to empty
      createTasksUnderTemplate(selectedTemplateArr, AllvaluefrontEndData);
      sendRespectiveEmail('created', newArr.taskName, 'Created Task', ''); //email Function
    } else {
      setErrorType('EmptyName');
    }
    setNewTask('');
  };
  //////////////////////////////////// Clone Data Function
  const handleClone = () => {
    let flag = 0;
    selectedTemplate?.tasks?.forEach((data) => {
      if (data.taskId === selectedTasks?.taskId) {
        flag = 1;
      }
    });
    if (
      selectedTemplate &&
      selectedTasks !== undefined &&
      newTask.length > 0 &&
      errorType !== 'dot' &&
      !/\s/g.test(newTask?.charAt(0) || '') &&
      flag
    ) {
      cloneTasks({
        id: selectedTemplate.templateId,
        cloned_from: selectedTasks.taskId,
        cloned_as: newTask,
      });
      sendRespectiveEmail('cloned', newTask, 'Cloned Task', ''); //email Function
    } else if (!flag) {
      setErrorType('selectionEmpty');
    } else if (newTask.length === 0) {
      setErrorType('EmptyName');
    }
    setNewTask('');
  };
  //////////////////////////////Drag and Drog
  const onDragEnd = async (result: DropResult) => {
    loadTaskById(result.draggableId);
    if (temptasks !== undefined && selectedTasks) {
      const { source, destination } = result;
      if (!destination) return;
      const items = Array.from(temptasks);
      const [newOrder] = items.splice(source.index, 1);
      items.splice(destination.index, 0, newOrder);
      settemptasks(items);
      const updatedIndex = items.map((data, index) => {
        const newArr = {
          ...data,
          taskIndex: index, //editing the task index
        };
        return newArr;
      });
      if (selectedTemplate !== undefined) {
        const selectedTemplateArr = {
          ...selectedTemplate,
          tasks: updatedIndex,
        };
        UpdateTemplate(selectedTemplateArr);
      }
    }
  };
  /////////////////////edit clicked
  const handleEdit = (id: string, name: string) => {
    setErrorType('');
    loadTaskById(id);
    setNewTask(name);
    workflowConfigurationStore.setEditClickedTask(true);
  };
  ////////////////////// Save Edited
  const handleSaveEdited = (name: string) => {
    if (
      selectedTasks &&
      selectedTemplate !== undefined &&
      name === 'edit' &&
      newTask.length !== 0
    ) {
      const newArr = {
        ...selectedTasks,
        taskName: newTask,
      };
      editTasks(newArr as TemplateTask);
      sendRespectiveEmail('edited', newArr.taskName, 'Edited Task', ''); //email Function
      const data = selectedTemplate?.tasks; //to update dom
      const index = data.findIndex(
        (obj) => obj.taskId === selectedTasks.taskId,
      );
      data[index].taskName = newTask;
    }
    setNewTask('');
    workflowConfigurationStore.setEditClickedTask(false);
  };
  ///////////////////////////// Delete Task
  const handleDelete = (task: TemplateTask) => {
    if (selectedTemplate !== undefined) {
      setErrorType('');
      setIsModalOpen(true);
      setTemplateTask(task);
    }
  };

  const deleteConfirmed = () => {
    setErrorType('');
    const TaskJSXs = selectedTemplate?.tasks;

    const taskArr = {
      ...templateTask,
      isDeleted: true,
    };
    //  const frontEndArr to show Delete
    const filterData =
      TaskJSXs !== undefined
        ? TaskJSXs.filter((item) => item.taskId !== templateTask.taskId)
        : [];
    const AllvaluefrontEndData = {
      ...selectedTemplate,
      tasks: filterData,
    };
    deleteTaskType(taskArr, AllvaluefrontEndData as Template);
    sendRespectiveEmail('deleted', taskArr.taskName, 'Deleted Task', ''); //email Function
    setIsModalOpen(false);
  };
  const TaskJSX = (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="templatepreset">
          {(provided) => (
            <div
              className="templatepreset workflow-config-tasks"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {temptasks?.map((tasks, index) => (
                <Draggable
                  key={tasks.taskId}
                  draggableId={tasks.taskId}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card>
                        <Card.Content
                          onClick={() => handleTaskJSX(tasks.taskId)}
                          onMouseEnter={() => setgetnewtaskkey(tasks.taskId)}
                          onMouseLeave={() => setgetnewtaskkey(null)}
                          className="hoverStyle" // Apply hover effect to the entire card
                          style={
                            tasks.taskId ===
                            workflowConfigurationStore.WorkflowConfiguration
                              .showTaskName
                              ? cardcolor
                              : null
                          }
                          key={tasks.taskId}
                        >
                          <Grid className="hoverColor" columns={3}>
                            <Grid.Row>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                {getnewtaskkey === tasks.taskId ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                    }}
                                    {...provided.dragHandleProps}
                                  >
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                    <Icon
                                      style={{
                                        cursor: 'all-Scroll',
                                        fontSize: '17px',
                                        left: 7,
                                        position: 'absolute',
                                        marginTop: '2px',
                                      }}
                                      name="ellipsis vertical"
                                      color="grey"
                                      size="small"
                                    />
                                  </div>
                                ) : null}
                              </Grid.Column>
                              <Grid.Column width={12}>
                                {tasks.taskName}
                              </Grid.Column>
                              <Grid.Column
                                width={2}
                                style={{
                                  padding: '0',
                                }}
                              >
                                <Checkbox
                                  onMouseEnter={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      true,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      false,
                                    )
                                  }
                                  key={index}
                                  style={{
                                    marginTop: '-3px',
                                    marginLeft: '-10px',
                                  }}
                                  onChange={(e: any, data: any) =>
                                    toggleOn(e, data, tasks)
                                  }
                                  name={tasks.taskId}
                                  className="table-toggle"
                                  toggle
                                  defaultChecked={tasks.isActive ? true : false}
                                />
                              </Grid.Column>
                              {getnewtaskkey === tasks.taskId ? (
                                <Label
                                  onMouseEnter={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      true,
                                    )
                                  }
                                  onMouseLeave={() =>
                                    workflowConfigurationStore.setDisableClick(
                                      false,
                                    )
                                  }
                                  attached="bottom right"
                                  style={{
                                    width: '92px',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <Grid>
                                    <Grid.Row
                                      style={{
                                        justifyContent: 'center',
                                      }}
                                    >
                                      <Grid.Column>
                                        <Icon
                                          name="pencil"
                                          color="grey"
                                          size="small"
                                          onClick={() =>
                                            handleEdit(
                                              tasks.taskId,
                                              tasks.taskName,
                                            )
                                          }
                                        />
                                      </Grid.Column>
                                      <Grid.Column
                                        style={{
                                          marginLeft: '2px',
                                        }}
                                      >
                                        <Icon
                                          name="trash"
                                          color="grey"
                                          size="small"
                                          onClick={() => handleDelete(tasks)}
                                        />
                                      </Grid.Column>
                                      {index !== 0 &&
                                        userStore.user?.customerName ===
                                          'NFAIReport' && (
                                          <Grid.Column
                                            style={{
                                              marginLeft: '2px',
                                            }}
                                          >
                                            <Icon
                                              name="setting"
                                              color="grey"
                                              size="small"
                                              onClick={() =>
                                                handleSettingsClick(
                                                  index,
                                                  tasks,
                                                  tasks.taskId,
                                                )
                                              }
                                            />
                                          </Grid.Column>
                                        )}
                                    </Grid.Row>
                                  </Grid>
                                </Label>
                              ) : null}
                            </Grid.Row>
                          </Grid>
                        </Card.Content>
                      </Card>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <Modal open={showSettingsModal} onClose={handleCloseSettingsModal}>
        <Modal.Header>Settings</Modal.Header>
        <Modal.Content>
          <Checkbox
            label="Parallel Task"
            checked={templateTask?.isParallel}
            onChange={handleCheckboxChange}
          />
          {templateTask.taskIndex !== 1 &&  (
            <Form.Field style={{ marginTop: '20px' }}>
              <label style={{ display: 'block', fontWeight: 'bold' }}>
                Set Dependency
              </label>
              <Dropdown
                placeholder="Select a Task"
                selection
                fluid
                clearable
                multiple={commonStore.NFAIReportCustomer}
                value={templateTask?.dependencyTask}
                options={options}
                onChange={handleDropdownChange}
                style={{
                  border: '1px solid #f4f4f4',
                  borderRadius: '4px',
                  marginTop: '10px',
                  padding: '8px',
                }}
              />
            </Form.Field>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={handleCloseSettingsModal}>
            Cancel
          </Button>
          <Button
            content="Save"
            labelPosition="right"
            icon="checkmark"
            positive
            onClick={handleTaskSettingsSave}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
  return (
    <div>
      {isModalOpen && (
        <Suspense fallback={<></>}>
          <DeleteModal
            isModalOpen={isModalOpen}
            closeHandler={() => {
              setIsModalOpen(false);
            }}
            deleteHandler={deleteConfirmed}
            header={'Delete'}
            text={
              'Are you sure you want to delete this? Deleting it will also remove all related data.'
            }
          />
        </Suspense>
      )}
      <Grid>
        <Card style={cardStyleLevel1}>
          <Header
            style={{ marginLeft: '20px', padding: '10px' }}
            size="huge"
            as="h1"
            content="task"
            sub
            color="grey"
          />

          {!selectedTemplate || loadingInitialTask ? (
            <LoadingComponent />
          ) : (
            TaskJSX
          )}
          <Segment className="workflow-bottom-card">
            <Form>
              <Form.Group widths="equal">
                <Form.Field
                  id="form-input-control-error-email"
                  className=" workflow-input"
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : errorType === 'dot'
                          ? errorDot
                          : errorType === 'selectionEmpty'
                            ? selectionEmptyErrorMsg
                            : null
                  }
                  control={Input}
                  value={newTask}
                  placeholder="Create New"
                  onChange={handleChangeName}
                  onKeyDown={handleKeyPress}
                />
              </Form.Group>
            </Form>
            {workflowConfigurationStore.WorkflowConfiguration
              .editClickedTask === false ? (
              <div className="workflow-input-div">
                {commonStore.filterModeTwo?.includes('SWB08') ? (
                  <></>
                ) : (
                  <Button
                    primary
                    onClick={handleClone}
                    className="workflow-input-button"
                    disabled={
                      commonStore.filterModeZero?.includes('SWB08') ||
                      errorType !== ''
                    }
                    error={
                      errorType === 'SameName'
                        ? errorMessageText
                        : errorType === 'EmptyName'
                          ? errorEmptyText
                          : errorType === 'selectionEmpty'
                            ? selectionEmptyErrorMsg
                            : null
                    }
                  >
                    Clone
                  </Button>
                )}

                {/* <Button
                  primary onClick={handleClone} className="workflow-input-button"
                  disabled={ (!dashboardStore.dashboard.selectedUserRoleId.includes("SWB08")||   errorType === "dot" )  ? true : false  ||
                  errorType === "SameName" || errorType === "EmptyName" ? true : false }
                  error={ errorType === "SameName" ? errorMessageText : errorType === "EmptyName" ? errorEmptyText : errorType ==='dot' ? errorDot :null }
                  >
                  Clone aaaa
                </Button> */}

                {commonStore.filterModeTwo?.includes('SWB06') ? (
                  <></>
                ) : (
                  <Button
                    color="green"
                    floated="right"
                    onClick={hanldeAddTasks}
                    className="workflow-input-button"
                    disabled={
                      commonStore.filterModeZero?.includes('SWB06') ||
                      errorType !== ''
                    }
                    error={
                      errorType === 'SameName'
                        ? errorMessageText
                        : errorType === 'EmptyName'
                          ? errorEmptyText
                          : errorType === 'selectionEmpty'
                            ? selectionEmptyErrorMsg
                            : null
                    }
                  >
                    Add New
                  </Button>
                )}

                {/* <Button
                  color="green" floated="right" onClick={hanldeAddTasks} className="workflow-input-button"
                  disabled={ !dashboardStore.dashboard.selectedUserRoleId.includes("SWB06") ? true : false ||
                  errorType === "SameName" || errorType === "EmptyName" || errorType ==='dot' ? true : false }
                  error={ errorType === "SameName" ? errorMessageText : errorType === "EmptyName" ? errorEmptyText : errorType ==='dot' ? errorDot :null } >
                  Add New
                </Button> */}
              </div>
            ) : (
              <div className="workflow-input-div">
                <Button
                  secondary
                  onClick={() => handleSaveEdited('cancel')}
                  className="workflow-input-button"
                >
                  Cancel
                </Button>
                <Button
                  primary
                  floated="right"
                  onClick={() => handleSaveEdited('edit')}
                  className="workflow-input-button"
                  disabled={errorType !== '' || newTask === ''}
                  error={
                    errorType === 'SameName'
                      ? errorMessageText
                      : errorType === 'EmptyName'
                        ? errorEmptyText
                        : errorType === 'dot'
                          ? errorDot
                          : errorType === 'selectionEmpty'
                            ? selectionEmptyErrorMsg
                            : null
                  }
                >
                  Save
                </Button>
              </div>
            )}
          </Segment>
        </Card>
        {workflowConfigurationStore.WorkflowConfiguration.showSubTaskCard ===
          true &&
        workflowConfigurationStore.WorkflowConfiguration.showSubTaskClicked ===
          true ? (
          <WorkflowSubtasks />
        ) : null}
      </Grid>
    </div>
  );
}

export default observer(WorkflowTasks);
